import LayoutBlank from '@/layout/LayoutBlank'

export default [{
  path: '',
  component: LayoutBlank,
  children: [
    {
      path: 'register',
      component: () => import('@/components/auth/Register'),
      name: 'Register',
      meta: { requiresAuth: false }
    },
    {
      path: 'login',
      component: () => import('@/components/auth/Login'),
      name: 'Login',
      meta: { requiresAuth: false }
    },
    {
      path: 'logout',
      component: () => import('@/components/auth/Logout'),
      name: 'Logout',
      meta: { requiresAuth: true }
    },
    {
      path: 'password/forgot',
      component: () => import('@/components/auth/EmailPassword'),
      name: 'ForgotPassword',
      meta: { requiresAuth: false }
    },
    {
      path: 'password/reset/:token',
      component: () => import('@/components/auth/ResetPassword'),
      name: 'ResetPassword',
      props: true,
      meta: { requiresAuth: false }
    }
  ]
}]
